import React from 'react';
import { VSpringIcon } from '@springcare/verdant-icons-react';
import { Flex, Icon, Box } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';

import { SideMenuItems } from './SideMenuItems';
import { ProfileMenu } from './ProfileMenu';
import { collapseButtonSize, sideNavWidth, sideNavWidthCollapsed } from './constants/styles';
import { AdminLogo } from '../AdminLogo';

interface SideMenuProps {
  callback: (data: object) => void;
  open: boolean;
  isDesktop: boolean;
}

export const SideMenu = ({ callback, open, isDesktop, ...rest }: SideMenuProps) => {
  const toggleOpenWithCallback = () => {
    callback({ open: !open });
  };

  return (
    <Box
      as="nav"
      height="100vh"
      width={open ? `${sideNavWidth}px` : `${sideNavWidthCollapsed}px`}
      display={isDesktop ? 'flex' : 'none'}
      flexDirection="column"
      data-testid="nav-side-menu"
      position="fixed"
      zIndex="3"
      backgroundColor="white"
      transition="width 0.3s ease"
      borderRight="2px solid"
      borderColor="background-disabled"
      boxShadow="xs"
      {...rest}
    >
      <Flex flexShrink={0} width="100%" padding={3} pt={6} justifyContent={open ? 'start' : 'center'}>
        {open ? <AdminLogo /> : <Icon as={VSpringIcon} color="primary-base" />}
      </Flex>
      <SideMenuItems menuOpen={open} />

      <Box
        as="button"
        data-testid="toggle-side-button"
        display={isDesktop ? 'flex' : 'none'}
        position="absolute"
        right={`${(collapseButtonSize / 2) * -1}px`}
        width={`${collapseButtonSize}px`}
        height={`${collapseButtonSize}px`}
        alignItems="center"
        justifyContent="center"
        borderRadius="50%"
        backgroundColor="white"
        border="1px solid #e9e9e9"
        bottom="100px"
        onClick={toggleOpenWithCallback}
      >
        {open ? <Icon as={ChevronLeftIcon} fontSize="16" /> : <Icon as={ChevronRightIcon} fontSize="16" />}
      </Box>
      <Box data-testid="side-menu-profile" flexShrink={0} paddingX={2} paddingBottom={4} width="100%">
        <ProfileMenu sideNavOpen={open} />
      </Box>
    </Box>
  );
};
